import React from 'react';
import styles from './appheader.module.css';
import Button from '../button/Button';
import Logo from '../logo/Logo';
import NavButton from '../navbutton/NavButton';
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useSiteConfig } from '../../contexts/SiteConfigContext';
import { useEscapeClose } from '../../hooks/useEscapeClose';

function AppHeader() {
  const navigate = useNavigate();
  const { links, newsSection } = useSiteConfig();
  const goToDonate = () => {
    navigate('/donate');
  }

  const location = useLocation();
  const windowWidth = React.useRef(window.innerWidth);

  // На телефоне пункты меню уходят под бургер: в строке остаются логотип,
  // «Пополнить счёт» и кнопка меню — шапка в одну строку, а не колонка на треть экрана
  const [menuOpen, setMenuOpen] = React.useState(false);
  useEscapeClose(() => setMenuOpen(false), menuOpen);
  React.useEffect(() => { setMenuOpen(false); }, [location.pathname]);

  return (
    <nav className={`${styles.nav} ${menuOpen ? styles.navOpen : ''}`}>
      <ul className={styles.ul}>
        <li className={styles.li}><Link to="/" aria-label="AmazingLife — RPG, на главную"><Logo/></Link></li>
        <div className={styles.rightContainer}>
          <div className={styles.links} id="site-menu">
            <li className={`${styles.li}`}><NavButton image='forum' link={links.forum}>ФОРУМ</NavButton></li>
            <li className={`${styles.li} ${styles.ml3}`}><NavButton image='rules' link="/rules">ПРАВИЛА</NavButton></li>
            {/* Раздел на обкатке: в состоянии hidden доступен по прямой ссылке, но не в меню */}
            {newsSection === 'on' && (
              <li className={`${styles.li} ${styles.ml3}`}><NavButton image='news' link="/news">НОВОСТИ</NavButton></li>
            )}
            <li className={`${styles.li} ${styles.ml3}`}><NavButton image='key' link="/panel">ЛИЧНЫЙ КАБИНЕТ</NavButton></li>
          </div>
          {!((location.pathname === '/donate') && (windowWidth.current < 720)) &&
            <li className={`${styles.li} ${styles.ml6}`}>
              <Button
                onClick={goToDonate}
                size={'small'}
                color={'gold'}
                text={'light'}
                borderRadius={6}
                type="button"
                disable={false}
              >
                ПОПОЛНИТЬ СЧЁТ
              </Button>
            </li>
          }
          <li className={styles.burgerItem}>
            <button
              type="button"
              className={styles.burger}
              aria-label={menuOpen ? 'Закрыть меню' : 'Открыть меню'}
              aria-expanded={menuOpen}
              aria-controls="site-menu"
              onClick={() => setMenuOpen(v => !v)}
            >
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
                {menuOpen ? <path d="M6 6l12 12M18 6L6 18" /> : <path d="M4 7h16M4 12h16M4 17h16" />}
              </svg>
            </button>
          </li>
        </div>
      </ul>
    </nav>
  );
}

export default AppHeader;
